import markerImage from 'images/index/map-marker@2x.png'

let map = null
let mapCenter = null
let baseZoom = null
let resizeTimer = null
let mapApiRequested = false

// SPモードでは少し引いて表示する
const effectiveZoom = function (zoom) {
  if (window.matchMedia('(max-width:767px)').matches) {
    return zoom - 2
  }
  return zoom
}

// 地図を1回だけ生成する。
// new google.maps.Map() は実行ごとに「Map Load」として課金されるため、
// resize のたびに作り直さないよう、生成はこの関数の呼び出し（= load時1回）に限定する。
const buildMap = function (lat, lng, zoom) {
  const mapId = 'map'
  const title = 'のいえ'
  const center = new window.google.maps.LatLng(lat, lng)
  const options = {
    zoom: effectiveZoom(zoom || 16),
    center: center,
    mapTypeId: window.google.maps.MapTypeId.ROADMAP,
    disableDefaultUI: true,
    type: false,
    zoomControl: true,
    scrollwheel: false,
  }
  // MapTypeStyle
  // https://lab.syncer.jp/Web/API/Google_Maps/JavaScript/MapTypeStyle/
  const style = [
    {
      featureType: 'transit',
      stylers: [{ saturation: -100 }],
    },
    {
      featureType: 'administrative',
      stylers: [{ visibility: 'off' }],
    },
    {
      featureType: 'poi',
      stylers: [{ saturation: -100 }],
    },
    {
      featureType: 'water',
      stylers: [{ color: '#e9e9e9' }, { lightness: 100 }],
    },
    {
      featureType: 'road',
      stylers: [{ saturation: -100 }],
    },
    {
      featureType: 'landscape',
      stylers: [
        { saturation: -100 },
        { lightness: 10 },
      ],
    },
    //全てのラベルを非表示
    {
      featureType: 'all',
      elementType: 'labels',
      stylers: [
        { visibility: 'off' },
      ],
    },
    // 鉄道駅を再表示
    {
      featureType: 'transit.station',
      elementType: 'labels',
      stylers: [
        { visibility: 'inherit' },
      ],
    },
    // 道路を再表示
    {
      featureType: 'road',
      elementType: 'labels',
      stylers: [
        { visibility: 'inherit' },
      ],
    },
    // 公園を再表示
    {
      featureType: 'poi',
      elementType: 'labels',
      stylers: [
        { visibility: 'inherit' },
      ],
    },
    // 企業、店舗 を表示
    {
      featureType: 'poi.business',
      elementType: 'labels.icon',
      stylers: [
        { visibility: 'inherit' },
      ],
    },
  ]

  // generate map
  const generated = new window.google.maps.Map(document.getElementById(mapId), options)
  new window.google.maps.Marker({
    position: center,
    icon: {
      url: markerImage,
      scaledSize: new window.google.maps.Size(42, 48),
    },
    map: generated,
    title: title,
  })
  generated.mapTypes.set('noText', new window.google.maps.StyledMapType(style, options))
  generated.setMapTypeId('noText')
  generated.setCenter(center)
  return generated
}

// Maps API 読み込み完了後にコールバックとして呼ばれる（apiSrc の &callback=window.initMap）
// 地図の生成はここで1回だけ行う。
window.initMap = () => {
  const el = $('#map')
  if (!el.length) return
  baseZoom = el.data('zoom') || 16
  mapCenter = new window.google.maps.LatLng(el.data('lat'), el.data('lng'))
  map = buildMap(el.data('lat'), el.data('lng'), baseZoom)
  el.attr('data-height', el.outerHeight())
}

// Maps API スクリプトを動的に注入する（1回だけ）。
// functions.php から wp_localize_script で渡された window.mapConfig.apiSrc を使う。
const loadMapApi = function () {
  if (mapApiRequested) return
  mapApiRequested = true
  const src = window.mapConfig && window.mapConfig.apiSrc
  if (!src) return
  const script = document.createElement('script')
  script.src = src
  script.async = true
  document.head.appendChild(script)
}

// IE対策、兼Chromeでも最初の読み込み時に高さがうまく設定されていなかったため
// resize 時は地図を作り直さず（= Map Load課金を発生させず）、
// 課金対象外の setCenter() / setZoom() で再センタリング・ズーム調整のみ行う。
window.resizeMap = () => {
  if (!map) return
  const el = $('#map')
  if (!el.length) return
  clearTimeout(resizeTimer)
  resizeTimer = setTimeout(function () {
    const mapHeight = el.outerHeight()
    // 前回と高さが変わっていた時だけ再センタリング（地図は作り直さない）
    if (!mapHeight || el.attr('data-height') != String(mapHeight)) {
      el.attr('data-height', mapHeight)
      map.setZoom(effectiveZoom(baseZoom))
      map.setCenter(mapCenter)
    }
  }, 500)
}

// #map が画面に入ってから（200px手前で先読み）Maps API を読み込む。
// 地図まで到達しなかった訪問では API 自体を読み込まず、Map Load 課金が発生しない。
$(function () {
  const target = document.getElementById('map')
  if (target) {
    const observer = new IntersectionObserver(function (entries) {
      for (let i = 0; i < entries.length; i++) {
        if (entries[i].isIntersecting) {
          loadMapApi()
          observer.disconnect()
          break
        }
      }
    }, { rootMargin: '200px' })
    observer.observe(target)
  }
})

$(window).on('resize', window.resizeMap)
